module.exports = __webpack_public_path__ + "f26abe04e46577e34cdf90128cbd28a0.fbx";